const pad = (value: number) => String(value).padStart(2, '0');

const buildTimestamp = (date: Date) => {
  const datePart = `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}`;
  const timePart = `${pad(date.getHours())}${pad(date.getMinutes())}${pad(date.getSeconds())}`;
  return `${datePart}-${timePart}`;
};

const getBaseName = (fileName = '') => {
  const name = fileName.split(/[\\/]/).pop() || '';
  return name.replace(/\.(html|htm)$/i, '').trim() || 'page';
};

export const buildDefaultHtmlFileName = (date = new Date()) => {
  return `page-${buildTimestamp(date)}.html`;
};

export const buildEditedHtmlFileName = (fileName = '', date = new Date()) => {
  return `${getBaseName(fileName)}-edited-${buildTimestamp(date)}.html`;
};

export const isValidHtmlFileName = (fileName = '') => {
  const trimmed = fileName.trim();
  return /^[^\\/]+\.(html|htm)$/i.test(trimmed);
};
